const ASBESTOS = {
  severity: "",
  likelihood: "",
  location: "",
  damage_potential: "",
  accessible: "",
  material_type: "",
  date_identified: "",
  condition: "",
  friability: "",
};

const BIOLOGICAL = {
  severity: "",
  likelihood: "",
  hazard: "",
  position_effected: "",
  route_of_infection: "",
  activity: "",
  effected: "",
};

const ENVIRONMENTAL = {
  severity: "",
  likelihood: "",
  location: "",
  aspect: "",
  impact: "",
  condition: "",
  control_influence: "",
  activity: "",
  current_controls: "",
};

const ERGONOMIC = {
  severity: "",
  likelihood: "",
  body_parts: "",
  activity: "",
  health_risk: "",
  current_controls: "",
};

const MANAGEMENT_OF_CHANGE = {
  severity: "",
  likelihood: "",
  risk_associated_with_change: "",
  description_of_change: "",
  mitigation: "",
};

const OCCUPATIONAL_HEALTH_AND_SAFETY = {
  activity: "",
  task: "",
  risk: "",
  hazard: "",
  severity: "",
  likelihood: "",
  current_controls: "",
};

const ROUTE_RISK_ASSESSMENT = {
  route_name: "",
  assessment_date: "",
  optimum_traffic_patterns_times: "",
  highly_hazardous_intersections_along_routes: "",
  any_overhead_hazards: "",
  construction_along_routes: "",
  access_to_delivery_points_along_routes: "",
  makeup_and_tonnage_of_each_shipment: "",
  severity: "",
  likelihood: "",
};

const CALCULATE_RISK = (data) => {
  let risk = 0;
  let baseline = 0;
  let color = "#28a745";

  if (data && data.severity && data.likelihood) {
    risk = parseInt(data.severity) * parseInt(data.likelihood);
    baseline = Math.floor(
      100 * ((parseInt(data.severity) + parseInt(data.likelihood)) / 10)
    );
  }

  if (risk > 10 && risk <= 20) {
    color = "#ffc107";
  } else if (risk > 20) {
    color = "#dc3545";
  }

  return { color, baseline };
};

const RISK_COLOR = (baseline) => {
  let color = "#28a745";
  baseline = parseInt(baseline);

  if (baseline > 35 && baseline <= 65) {
    color = "#ffc107";
  } else if (baseline > 65) {
    color = "#dc3545";
  }

  return { color };
};

export {
  ASBESTOS,
  BIOLOGICAL,
  ENVIRONMENTAL,
  ERGONOMIC,
  MANAGEMENT_OF_CHANGE,
  OCCUPATIONAL_HEALTH_AND_SAFETY,
  ROUTE_RISK_ASSESSMENT,
  CALCULATE_RISK,
  RISK_COLOR,
};



// WEBPACK FOOTER //
// ./src/screens/risks/Constants.js